import TransactionService from '@/services/transaction';

export default {
	namespaced: true,
	state: {
	},

	getters: {
		// async getPemasukan({ commit, state, getters, dispatch }) {
		// 	try {
		// 		const userLogin = JSON.parse(window.localStorage.getItem('user_data'))
		// 		let response
		// 		if (userLogin.role.name == 'accountant') {
		// 			response = await PemasukanService.getPemasukanByType('PEMASUKAN')
		// 			// console.log('response', response)
		// 		} else {
		// 			response = await PemasukanService.getPemasukanByUser()
		// 		}
		// 		return response
		// 	} catch (e) {
		// 		console.log(e)
		// 	}
		// }
	},

	actions: {
		async getTransactionBySubmissionId({ commit, state, getters, dispatch }, id) {
			let response
			try {
				response = await TransactionService.getTransactionBySubmissionId(id);
			} catch (e) {
				console.log(e);
			}
			return response
		},
		async createTransaction({ commit, state, getters, dispatch }, payload) {
			let response
			try {
				response = await TransactionService.createTransaction(payload);
			} catch (e) {
				console.log(e);
			}
			return response
		},
		// async updatePemasukan({ commit, state, getters, dispatch }, payload) {
		// 	try {
		// 		const userLogin = JSON.parse(window.localStorage.getItem('user_data'))
		// 		// console.log(payload)
		// 		if (userLogin.role.name != 'accountant') {
		// 			payload.status = 'PENDING'
		// 		}
		// 		await PemasukanService.updatePemasukan(payload.id, {
		// 			...payload
		// 		})
		// 	} catch (e) {
		// 		console.log(e);
		// 	}
		// },
		async deleteTransaction({ commit, state, getters, dispatch }, id) {
			let response
			try {
				response = await TransactionService.deleteTransaction(id);
			} catch (e) {
				console.log(e);
			}
			return response
		}
	},

	mutations: {
		// SET_VALUE_FROM_API(state, payload) {
		// 	state.valueFromApi = payload;
		// }
	}
};
